import React from "react";
import { Card } from "antd";
import PropTypes from "prop-types";

const Widget = ({ title, children, styleName, cover, extra, actions, style }) => {

  return (
    <Card title={title} actions={actions} cover={cover} className={`gx-card-widget gx-my-3 ${styleName}`} extra={extra} style={{ borderRadius: 10, ...style }}>
      {children}
    </Card>
  )
};

export default Widget;
Widget.defaultProps = {
  styleName: '',
};

Widget.propTypes = {
  title: PropTypes.node,
  extra: PropTypes.node,
  cover: PropTypes.node,
  actions: PropTypes.node,
  children: PropTypes.node.isRequired
};
